'use client';

//base
import React from 'react';

import { TextField, type TextFieldProps } from '@mui/material';

export const BasicTextField: React.FC<TextFieldProps> = ({ ...props }) => {
  return (
    <TextField
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '6px',
          backgroundColor: '#fff'
        },

        '& .MuiInputBase-input.Mui-disabled': {
          backgroundColor: '#f0f0f0',
          borderRadius: '6px'
        }
      }}
      inputProps={{
        style: {
          padding: '8px 12px'
        }
      }}
      {...props}
    />
  );
};
